import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const TatReportView = ({ data,isLoading}:any) => {
  const report = data?.res || data; // support both data and data.res
   
  if (!report || !report.categoriesJson?.length || !report.chartSeries?.length) {
   
      
         return !isLoading?(<div>No Data Found</div>):(<div>Loading chart...</div>);
       
   
  }

    const formatDuration = (totalMinutes: number): string => {
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
  
    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`);
  
    return parts.join(' ');
  };

  // const options: Highcharts.Options = {
  //   chart: { type: "column" },
  //   title: { text: "Day Wise TAT (Min / Max / Avg)" },
  //   xAxis: { categories: report.categoriesJson, crosshair: true },
  //   yAxis: { min: 0, title: { text: "TAT (minutes)" } },
  //   tooltip: { shared: true, valueSuffix: " min" },
  //   plotOptions: { column: { borderRadius: 5, pointPadding: 0.2, groupPadding: 0.1 } },
  //   credits: { enabled: false },
  //   series: report.chartSeries.map((s: any) => ({
  //     type: "column",
  //     name: s.name,
  //     data: s.data.map((d: any) => Number(d)),
  //   })),
  // };

  const options: Highcharts.Options = {
      chart: {type: 'line',},
      title: {  text: 'TAT (Turn Around Time) Report',},
      subtitle: {  useHTML: true, },
      xAxis: { categories:report.categoriesJson || [] ,
      title: {  text: '',},
      },
      yAxis: {  title: { text: 'TAT', }, labels: {
          formatter: function () {
            return formatDuration(this.value as number);
          }
        }},
         tooltip: {
        formatter: function () {
          return `<b></b> ${formatDuration(this.y as number)}`;
        }
      },
     plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return formatDuration(this.y as number);
            }
          }
        }
      },
      credits: {
    enabled: false
  },
      series:report.chartSeries || [] ,
};
        

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
